
import React from 'react'
import AdminSettingTabs from './SettingTabs'

const AdminSettings = () => {
    return (
        <>
            <section className='py-3 md:py-5'>
                <AdminSettingTabs />
            </section>
        </>
    )
}

export default AdminSettings